/**
 * Cache org-level Job Scope Grouping opt-in from /api/rbac/permissions/.
 * Main dashboard hooks read this to avoid 404s when the feature is off.
 */

const KEY_PREFIX = 'quotech:enable_job_scope_grouping:'

export function cacheJobScopeGroupingEnabled(
  orgId: string | number | null | undefined,
  enabled: boolean,
): void {
  if (orgId == null || orgId === '') return
  try {
    sessionStorage.setItem(`${KEY_PREFIX}${orgId}`, enabled ? '1' : '0')
    window.dispatchEvent(
      new CustomEvent('quotech:org-features-updated', { detail: { orgId: String(orgId), enabled } }),
    )
  } catch {
    // sessionStorage unavailable — hooks default to disabled
  }
}

export function readJobScopeGroupingEnabled(
  orgId: string | number | null | undefined,
): boolean {
  if (orgId == null || orgId === '') return false
  try {
    return sessionStorage.getItem(`${KEY_PREFIX}${orgId}`) === '1'
  } catch {
    return false
  }
}
